// Rexy's day chats on the desktop (owner ruling 2026-10-16). Every day is its own chat,
// and the server routes every Rexy contact into today's. So "New chat" and "End chat"
// both take him to TODAY's chat: no undated "Chat N" is created and nothing is closed.
//
// Today's chat is resolved by the server — GET /conversation with no thread returns
// its id (opening it on the day's first contact) — never by a clock on this machine.
//
// Pure apart from the injected `get` → node-testable (rexyDayChat.test.mjs).

async function openTodaysChat(get, apiBase, domain, agent, headers) {
  const conv = await get(apiBase + '/conversation', {
    params: { domain: domain, agent: agent }, withCredentials: true, headers: headers || {},
  });
  const threadId = conv && conv.data ? conv.data.thread_id : null;
  if (!threadId) return null;
  const list = await get(apiBase + '/threads', {
    params: { domain: domain, agent: agent }, withCredentials: true,
  });
  return { threadId: threadId, threads: (list && list.data && list.data.threads) || [] };
}

module.exports = { openTodaysChat };
